
import { useCharactersStore } from '@/features/shared/stores/characters.store'
import { useWorkspace } from '@/features/workspace/stores/workspace.store'
import { getCharacters } from '@/service/local-db'
import { db } from '@/shared/lib/db'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSpEditorStore } from '../stores/sp-editor.store'

export const useScreenplayEditor = () => {
    // Priority: Route param -> Workspace Store
    const { projectId: routeProjectId } = useParams<{ projectId: string }>()
    const { project } = useWorkspace()
    const projectId = routeProjectId || project?.id
        // Wait, screenplayId might not be available if we are just opening by title or list?
    // The current route structure for screenplay needs to be checked.
    // Assuming we have projectId.
    
    // Actually, looking at SpEditorProvider, it uses `useWorkspace` to get project.
    // And it seems to load characters. 
    // It doesn't seem to load screenplay content *by ID* in the provider specifically, 
    // but rather it has `screenplayEntity` state.
    
    const setCharacters = useCharactersStore(state => state.setCharacters)
    const setFeaturesEnabled = useSpEditorStore(state => state.setFeaturesEnabled)

    useEffect(() => {
        const fetchCharacters = async () => {
            if (!projectId) return
            try {
                const stored = await getCharacters(projectId)
                if (stored) {
                    setCharacters(stored)
                }
            } catch (error) {
                console.warn('Failed to fetch characters', error)
            }
        }
        fetchCharacters()
    }, [projectId, setCharacters])

    useEffect(() => {
        const features = localStorage.getItem('spFeaturesEnabled')
        if (features) {
            setFeaturesEnabled(JSON.parse(features))
        }
    }, [setFeaturesEnabled])

    // Character addition logic that persists to DB
    const addCharacterToDb = async (character: any) => {
             if (!projectId) return
             const fullCharacter = {
                 id: crypto.randomUUID(), 
                 ...character,
                 projectId: projectId,
             }
             await db.characters.add(fullCharacter) // This should be moved to a repository/mutation ideally
             // But for now, keeping it here to match existing logic, but connecting to store
             useCharactersStore.getState().addCharacter(fullCharacter)
    }

    return {
        addCharacterToDb
    }
}
